import ApexCharts from "apexcharts";
import moment from "moment";
import {
  DATE_RANGE_DEFAULT_HISTOGRAM_INTERVAL,
  DATE_RANGE_DEFAULT_HISTOGRAM_INTERVAL_FOR_MOBILE_DEVICES
} from "../constants/dashboard/dashboardModuleConstants";
import { findStringFirstOcurrenceIndexInArray } from "./stringHelper";
import { sendEventLegendClick } from "../../services/dashboardAnalyticEventService";

export const getApexchartsChartIdByItsOpts = (opts: { globals: { chartID: string; }; }) => opts.globals.chartID;

export const apexChartInvertedSeriesClickHandler = (_chart: any, seriesIndex: number, opts: { config: { series: any[]; }; globals: { collapsedSeries: { index: number; }[]; }; }) => {
  // @ts-ignore
  const chartId = getApexchartsChartIdByItsOpts(opts);
  const chart = ApexCharts.getChartByID(chartId);

  sendEventLegendClick(chartId);

  const allSeriesNames = opts.config.series.map((series: { name: any; }) => series.name);
  const clickedSeriesName = allSeriesNames[seriesIndex];
  const unClickedSeriesNames = allSeriesNames.filter((series: any) => series !== clickedSeriesName);

  const hiddenSeriesNames = opts.globals.collapsedSeries.map(({ index }) => allSeriesNames[index]);
  const shownSeriesNames = allSeriesNames.filter((series: any) => !hiddenSeriesNames.includes(series));

  const noSeriesSelected = opts.globals.collapsedSeries.length === 0;
  const actionWillUnselectAll = JSON.stringify(shownSeriesNames) === JSON.stringify([clickedSeriesName]);

  if (actionWillUnselectAll) {
    allSeriesNames.forEach((series: string) => chart.showSeries(series));
  } else if (noSeriesSelected) {
    unClickedSeriesNames.forEach((series: string) => chart.toggleSeries(series));
  } else {
    chart.toggleSeries(clickedSeriesName);
  }
};

export const getXAxisTooltipFormatterBasedOnRange = (date: moment.MomentInput, obj: { w: { config: { xaxis: { categories: any; }; }; }; }) => {
  const today = moment();
  const dateArray = obj.w.config.xaxis.categories;
  const currentDateIndexOnArray = findStringFirstOcurrenceIndexInArray(date, dateArray);
  const currentDateObject = moment(date, "YYYY-MM-DD");

  const isCurrentDateToday = currentDateObject.isSame(today, "day");
  const isSingleDayRange =
    moment(dateArray[currentDateIndexOnArray + 1], "YYYY-MM-DD").diff(
      moment(dateArray[currentDateIndexOnArray], "YYYY-MM-DD"),
      "days"
    ) === 1;

  const singleDayTooltipFormatter = () => {
    const [dayString, monthString, yearString] = moment(date, "YYYY-MM-DD").format("DD MMMM YYYY").split(" ");
    return `${dayString} ${monthString.charAt(0).toUpperCase()}${monthString.substring(1)} ${yearString}`;
  };

  const rangeTooltipFormatter = (toDate: moment.MomentInput) => {
    const fromDateString = moment(date, "YYYY-MM-DD").format("DD/MM/YY");
    const isCurrentDateLastDate = currentDateIndexOnArray === dateArray.length - 1;

    if (isCurrentDateLastDate) {
      const todayDateString = moment().format("DD/MM/YY");
      return `${fromDateString} a ${todayDateString}`;
    }

    const toDateString = moment(toDate, "YYYY-MM-DD").subtract(1, "day").format("DD/MM/YY");
    return `${fromDateString} a ${toDateString}`;
  };

  if (isSingleDayRange || isCurrentDateToday) return singleDayTooltipFormatter();

  const nextDateObject = moment(dateArray[currentDateIndexOnArray + 1], "YYYY-MM-DD");
  return rangeTooltipFormatter(nextDateObject);
};

export const getDateInterval = (dateRange: keyof typeof DATE_RANGE_DEFAULT_HISTOGRAM_INTERVAL, mobile: boolean) => {
  if (typeof dateRange !== "string") return DATE_RANGE_DEFAULT_HISTOGRAM_INTERVAL.LAST_YEAR;

  return mobile
    ? DATE_RANGE_DEFAULT_HISTOGRAM_INTERVAL_FOR_MOBILE_DEVICES[dateRange]
    : DATE_RANGE_DEFAULT_HISTOGRAM_INTERVAL[dateRange];
};
